import { Link } from 'react-router-dom';
import { ArrowRight, MapPin, Sparkles, Award } from 'lucide-react';
import { IMG } from '../data';

export default function About() {
  return (
    <div data-testid="about-page" className="pt-32 pb-24 bg-[#0a0a0a] text-white min-h-screen">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <span className="pill mb-4">Our Story</span>
        <h1 className="font-display font-light text-5xl sm:text-6xl lg:text-7xl tracking-tighter max-w-3xl">Detailing built around your life.</h1>

        <div className="grid lg:grid-cols-2 gap-12 mt-16 items-center">
          <div>
            <img src={IMG.luxury2} alt="Premium detailing" className="rounded-2xl w-full h-auto object-cover" />
          </div>
          <div className="space-y-6 text-zinc-300 leading-relaxed">
            <span className="pill mb-2">3+ Years Of Detailing Experience</span>
            <p>Express Detailz was founded with a simple belief: premium detailing shouldn&apos;t mean waiting in a shop. We bring the studio to your driveway.</p>
            <p>Based in Lincoln, Nebraska, we specialize in high-end and luxury vehicles, but every car — from a daily commuter to an exotic — receives the same painstaking, panel-by-panel care. We also detail <span className="text-white font-medium">semi trucks and boats</span>, and offer custom <span className="text-white font-medium">fleet detailing</span> for businesses with multiple vehicles.</p>
            <p>Our service truck shows up packed with everything we need — pro-grade chemicals, soft-touch wash media, hot-water extractors, steam, and ceramic-safe products. With <span className="text-white font-medium">3+ years of professional detailing</span> behind every appointment, the result is a dealership-quality finish without you ever leaving home or work.</p>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mt-20">
          <div className="bg-[#141414] border border-white/5 rounded-2xl p-8">
            <MapPin className="w-6 h-6 text-blue-400 mb-4" />
            <h3 className="font-display text-xl mb-2">Locally Owned</h3>
            <p className="text-zinc-400 text-sm">Proudly serving Lincoln and surrounding Nebraska communities.</p>
          </div>
          <div className="bg-[#141414] border border-white/5 rounded-2xl p-8">
            <Sparkles className="w-6 h-6 text-blue-400 mb-4" />
            <h3 className="font-display text-xl mb-2">Luxury Specialists</h3>
            <p className="text-zinc-400 text-sm">Trained on exotic and high-end finishes — soft, ceramic-safe methods only.</p>
          </div>
          <div className="bg-[#141414] border border-white/5 rounded-2xl p-8">
            <Award className="w-6 h-6 text-blue-400 mb-4" />
            <h3 className="font-display text-xl mb-2">Satisfaction Guaranteed</h3>
            <p className="text-zinc-400 text-sm">We don&apos;t leave until you&apos;re delighted with the result. Period.</p>
          </div>
        </div>

        <div className="mt-20 flex flex-wrap gap-4">
          <Link to="/book" data-testid="about-book" className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-full font-medium transition-all hover:shadow-[0_0_40px_rgba(37,99,235,0.5)] inline-flex items-center gap-2">
            Book Your Detail <ArrowRight className="w-4 h-4" />
          </Link>
          <Link to="/services" className="border border-white/20 hover:bg-white/10 text-white px-8 py-4 rounded-full font-medium">View Services</Link>
        </div>
      </div>
    </div>
  );
}
